import { Editor } from 'react-draft-wysiwyg';
import styles from './newsEditor.module.css';
import ImageUploadPreview from './ImageUploadPreview';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
const StyleOneContent = ({
    image,
    setImage,
    editorStateTop,
    setEditorStateTop,
    editorStateBottom,
    setEditorStateBottom,
    imageWidthRatio,
    setImgText,
    imgText
}) => {

    return (
        <>
            <div className={styles.option1Layout}>
                <div style={{ flexBasis: `${imageWidthRatio}%` }}>
                    <ImageUploadPreview
                        label="Bild hochladen (Option 1)"
                        image={image}
                        setImage={setImage}
                        imgText={imgText}
                        setImgText={setImgText}
                    />
                </div>
                <div style={{ flex: 1 }} className={styles.textEditor}>
                    <Editor
                        editorState={editorStateTop}
                        onEditorStateChange={setEditorStateTop}
                        wrapperClassName={styles.editorWrapper}
                        editorClassName={styles.editor}
                        toolbar={{
                            options: [
                                'inline',
                                'blockType',
                                'list',
                                'textAlign',
                                'link',
                                'emoji',
                                'history'
                            ],
                            blockType: {
                                options: [
                                    'Normal', // unstyled text
                                    'H2',
                                    'H3',
                                ],
                            },
                            inline: {

                                options: ['bold', 'italic', 'underline', 'strikethrough', 'monospace', 'superscript', 'subscript'],
                            },
                            list: {

                                options: ['unordered', 'ordered', 'indent', 'outdent'],
                            },
                            textAlign: {

                                options: ['left', 'center', 'right', 'justify'],
                            },
                            link: {
                                inDropdown: false,
                                // options: ['link', 'unlink'],
                            },
                            history: {
                                options: ['undo', 'redo'],
                            }
                        }}
                    // hashtag={{
                    //     separator: ' ',
                    //     trigger: '#',
                    // }}
                    // mention={{
                    //     separator: ' ',
                    //     trigger: '@',
                    //     suggestions: [
                    //         { text: 'JavaScript', value: 'javascript', url: 'js' },
                    //         { text: 'Golang', value: 'golang', url: 'go' },
                    //     ],
                    // }}
                    />

                </div>
            </div>
            {/* Optional second editor */}

            <div className={styles.textEditor}>
                <Editor
                    editorState={editorStateBottom}
                    onEditorStateChange={setEditorStateBottom}
                    wrapperClassName={styles.editorWrapper}
                    editorClassName={styles.editor}
                    toolbar={{
                        options: [
                            'inline',
                            'blockType',
                            'fontSize',
                            'fontFamily',
                            'list',
                            'textAlign',
                            'link',
                            'emoji',
                            'history'
                        ],
                        blockType: {
                            options: [
                                'Normal', // unstyled text
                                'H2',
                                'H3',
                            ],
                        },
                        inline: {

                            options: ['bold', 'italic', 'underline', 'strikethrough', 'monospace', 'superscript', 'subscript'],
                        },
                        list: {

                            options: ['unordered', 'ordered', 'indent', 'outdent'],
                        },
                        textAlign: {

                            options: ['left', 'center', 'right', 'justify'],
                        },
                        link: {
                            inDropdown: true,
                            options: ['link', 'unlink'],
                        },
                        history: {
                            options: ['undo', 'redo'],
                        }
                    }}
                    hashtag={{
                        separator: ' ',
                        trigger: '#',
                    }}
                    mention={{
                        separator: ' ',
                        trigger: '@',
                        suggestions: [
                            { text: 'JavaScript', value: 'javascript', url: 'js' },
                            { text: 'Golang', value: 'golang', url: 'go' },
                        ],
                    }}
                />
            </div>
        </>
    );
};

export default StyleOneContent;
